var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticStyle:{"text-align":"center","font-size":"16px","margin-top":"40%"}},[_vm._v("出错了！")])])}]

export { render, staticRenderFns }